import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { FooterContext } from "@insite/content-library/Pages/Footer";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import themeColors, { themeFontSizes, themeFontWeights, themeIndentSizes } from "@MasterBluePrint/Styles/variables";
import React, { FC } from "react";
import { css } from "styled-components";

interface OwnProps extends WidgetProps {
    extendedStyles?: FooterContainerStyles;
}

export interface FooterContainerStyles {
    widgetGridContainer?: GridContainerProps;
    mainFooterWrapGridItem?: GridItemProps;
}

export const footerContainerStyles: FooterContainerStyles = {
    widgetGridContainer: {
        gap: 0,
        css: css`
            background: ${getColor("primary.main")};
            max-width: 1440px !important;
        `,
    },
    mainFooterWrapGridItem: {
        width:12,
        css: css`
            margin:0 auto !important;
            font-family: 'Lato', sans-serif;
            letter-spacing:0;
            color: ${getColor("common.accent")};
            .footerContent {
                background: ${getColor("primary.main")};
                box-shadow: 100em 0 0 0 ${getColor("primary.main")}, -100em 0 0 0 ${getColor("primary.main")};
                display:flex;
                flex-flow:row;
                line-height:1.5;
                font-size:.875rem;
                font-weight:700;
                padding:33px 0 54px 0;
                max-width:1380px;
                margin:0 auto;
            }
            .footerContent div.footerAssist {
                font-size:1.066rem;
                margin-bottom:30px;
            }
            .footerContent div.footerFollow a {
                display:inline-block;
                margin-right:.4375rem;
                border-radius:5px;
                outline:0;
            }
            .footerContent div.footerFollow a:hover {outline:2px solid #F7F9FA;}
            .footerContent div.footerFollow a img {display:block;}
            .footerContent > div {
                flex:1 19%;
                margin-left:1%;
            }
            .footerContent > div ul li {margin-bottom:4px;}
            .footerContent a {text-decoration:none;}
            .footerContent a:hover {text-decoration:underline;}
            .footerContent > div h2 {
                color:${getColor("secondary.main")};
                line-height:1.1;
                font-size:1.066rem;
                margin-bottom:10px;
            }
            .footerContent div.footerAssist h2 {margin-bottom:0;}
            .footerContent div.footerFollow h2 {margin-bottom:6px;}
            .footerDivider {
                border:0;
                height:1px;
                background-color:#535e64;
                margin:0;
                box-shadow: 100em 0 0 0 #535e64, -100em 0 0 0 #535e64;
                font-size:.875rem;
            }
            .footerLegal {
                display:flex;
                flex-flow:row;
                align-items:center;
                background: #001D42;
                box-shadow: 100em 0 0 0 #001D42, -100em 0 0 0 #001D42;
                line-height:1.5;
                font-size:.8rem;
                font-weight:700;
                padding:8px 0 7px 0;
                max-width:1380px;
                margin:0 auto;
            }
            .footerLegal > span {
                flex:1 49%;
                margin-left:1%;
                display:flex;
                flex-flow:row wrap;
            }
            .footerLegal > span:last-of-type {
                margin-left:0;
                margin-right: 1%;
                justify-content:right;
            }
            .footerLegal > span img {display:block;}
            #copyCurrentYear {margin-right:3px;}
            .arrMobileBreak {margin-left:3px;}
            @media screen and (max-width: 1536px) {
                .footerContent > div {
                    flex:1 18%;
                    margin-left:2%;
                }
                .footerLegal > span {
                    flex:1 48%;
                    margin-left: 2%;
                }
                .footerLegal > span:last-of-type {margin-right: 2%;}
            }
            @media screen and (max-width: 1280px) {
                .footerContent {flex-flow:row wrap;}
                .footerContent > div {flex:1 23%;}
                .footerResources {margin-bottom:44px;}
                .footerConnect {
                    display:flex;
                    flex-flow:row;
                    align-items:center;
                }
                .footerContent div.footerAssist {
                    margin-bottom:0;
                    padding-right:20px;
                    display:flex;
                    flex-flow:row;
                    align-items:center;
                }
                .footerContent div.footerAssist h2 {margin-right:5px;}
                .footerContent div.footerAssist a {line-height:0;}
                .footerContent div.footerFollow {
                    border-left:1px solid #535e64;
                    padding-left:20px;
                    display:flex;
                    flex-flow:row;
                    align-items:center;
                }
                .footerContent div.footerFollow h2 {
                    margin-bottom:0;
                    padding-right:15px;    
                }
            }
            @media screen and (max-width: 768px) {
                .footerContent {padding:54px 0;}
                .footerContent > div {
                    flex:1 42%;
                    margin-left:8%;
                }
                .footerConnect {
                    flex-flow:row wrap;
                    margin-top:42px;
                }
                .footerContent div.footerAssist {
                    flex:1 100%;
                    margin-bottom:25px;
                    padding-right:0;
                }
                .footerContent div.footerFollow {
                    flex:1 100%;
                    border-left:0;
                    padding-left:0;
                }
                .footerLegal {
                    flex-flow:row wrap;
                    padding:11px 0 7px 0;
                }
                .footerLegal > span {
                    order:2;
                    flex:1 100%;
                    margin-left:0;
                    justify-content:center;
                }
                .footerLegal > span:first-of-type {
                    margin-top:6px;
                    display:block;
                    text-align:center;
                }
                .arrMobileBreak {
                    display:block;
                    margin-left:0;
                }
                .footerLegal > span:last-of-type {
                    order:1;
                    margin-right: 0;
                    justify-content:center;
                }
            }
            @media screen and (max-width: 430px) {
                .footerContent > div {
                    flex:1 88%;
                    margin-bottom:50px;
                    margin-left:12%;
                }
                .footerConnect {margin-top:0;}                
            }
            @media screen and (max-width: 360px) {
                .footerContent div.footerAssist {flex-flow:row wrap;}
                .footerContent div.footerAssist h2 {
                    flex:1 100%;
                    margin-right:0;
                }
                .footerContent div.footerAssist a {line-height:1.5;}
                .footerContent div.footerFollow {flex-flow:row wrap;}               
                .footerContent div.footerFollow h2 {
                    flex:1 100%;
                    margin-bottom:6px;
                    padding-right:0;    
                } 
            }
        `,
    },
};

const FooterContainer: FC<OwnProps> = ({ id, extendedStyles }) => {
    const [styles] = React.useState(() => mergeToNew(footerContainerStyles, extendedStyles));
    return (
        <GridContainer {...styles.widgetGridContainer}>
            <GridItem {...styles.mainFooterWrapGridItem}>
                <Zone zoneName="mainFooterWrap" contentId={id} />
            </GridItem>
        </GridContainer>
    );
};

const footerContainer: WidgetModule = {
    component: FooterContainer,
    definition: {
        group: "Footer",
        allowedContexts: [FooterContext],
    },
};

export default footerContainer;
